module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"header":"Oddziały","departments":"Nasze oddziały","department":"Oddział","departmentSite":"Strona oddziału"},"en":{"header":"Branches","departments":"Our branches","department":"Branch","departmentSite":"Branch page"}}')
  delete Component.options._Ctor
}
